<template>
  <ComponentsLoader v-editor-target="'content'" :components="components" />
</template>

<script setup>
defineProps({
  components: { type: Array, default: () => [] },
})
// We need this component to provide the isSustainabilityArticleWithSidebar variable to the child components
provide('isSustainabilityArticleWithSidebar', true)
</script>
